import { InjectionToken, Inject, ElementRef, Renderer2, Directive, Input, NgModule, ɵɵdefineInjectable, ɵɵinject, PLATFORM_ID, Injectable, EventEmitter, Component, Output, TemplateRef, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import isArray from 'lodash.isarray';
import isNumber from 'lodash.isnumber';
import isPlainObject from 'lodash.isplainobject';
import isString from 'lodash.isstring';
import isBoolean from 'lodash.isboolean';
import isUndefined from 'lodash.isundefined';
import set from 'lodash.set';
import { HttpErrorResponse, HttpClient, HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BehaviorSubject, ReplaySubject, of, throwError } from 'rxjs';
import { tap, mapTo, catchError, finalize, share, switchMap, map } from 'rxjs/operators';
import isEmpty$1 from 'lodash.isempty';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { __rest } from 'tslib';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import _get from 'lodash.get';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/router';

const _c0 = ["*"];
const QaLocatorsConfigToken = new InjectionToken('QaLocatorsConfig');

var QaLocatorTypes;
(function (QaLocatorTypes) {
    QaLocatorTypes["id"] = "test-id";
    QaLocatorTypes["type"] = "test-type";
    QaLocatorTypes["state"] = "test-state";
    QaLocatorTypes["target"] = "test-target";
    QaLocatorTypes["loading"] = "test-loading";
})(QaLocatorTypes || (QaLocatorTypes = {}));

class BaseQaLocatorDirective {
    constructor(config, element, renderer) {
        this.config = config;
        this.element = element;
        this.renderer = renderer;
        this.inputDataType = 'string';
        this.shouldBeUsedWithIdLocator = true;
    }
    ngOnInit() {
        this.validate();
        this.setupLocator();
    }
    validate() {
        this.validateInput();
        this.validateLocation();
    }
    validateInput() {
        const isNotCorrectInputDataType = typeof this.input !== this.inputDataType;
        if (isNotCorrectInputDataType) {
            throw new ReferenceError(`QaLocator(${this.attributeName}) must be a ${this.inputDataType}!`);
        }
    }
    validateLocation() {
        const { shouldBeUsedWithIdLocator, attributeName } = this;
        const isNotIdLocator = this.attributeName !== QaLocatorTypes.id;
        const hasIdLocator = Boolean(this.element.nativeElement.getAttribute(QaLocatorTypes.id));
        const hasNotRightLocation = shouldBeUsedWithIdLocator !== hasIdLocator;
        if (isNotIdLocator && hasNotRightLocation) {
            throw new ReferenceError(`QaLocator(${attributeName}) must be used ${shouldBeUsedWithIdLocator ? 'with' : 'without'} QaLocator(${QaLocatorTypes.id})`);
        }
    }
    setupLocator() {
        if (this.config.shouldSetupLocators) {
            this.renderer.setAttribute(this.element.nativeElement, this.attributeName, this.overridedInput || this.input);
        }
    }
}
BaseQaLocatorDirective.ɵfac = function BaseQaLocatorDirective_Factory(t) { return new (t || BaseQaLocatorDirective)(ɵngcc0.ɵɵdirectiveInject(QaLocatorsConfigToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
BaseQaLocatorDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BaseQaLocatorDirective });
BaseQaLocatorDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [QaLocatorsConfigToken,] }] },
    { type: ElementRef },
    { type: Renderer2 }
];


class TestIdDirective extends BaseQaLocatorDirective {
    constructor() {
        super(...arguments);
        this.attributeName = QaLocatorTypes.id;
    }
    validateInput() {
        super.validateInput();
        const testId = this.input;
        const regExp = new RegExp('^[A-Z_]*\\.[A-Z_]*$');
        const isNotMatchedToTemplate = !regExp.test(testId);
        if (isNotMatchedToTemplate) {
            throw new ReferenceError(`QaLocator(${this.attributeName}) does't match to format "[PAGE_NAME].[COMPONENT_NAME]"`);
        }
    }
}
TestIdDirective.ɵfac = function TestIdDirective_Factory(t) { return ɵTestIdDirective_BaseFactory(t || TestIdDirective); };
TestIdDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TestIdDirective, selectors: [["", "mmTestId", ""]], inputs: { input: ["mmTestId", "input"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
TestIdDirective.propDecorators = {
    input: [{ type: Input, args: ['mmTestId',] }]
};
const ɵTestIdDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(TestIdDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TestIdDirective, [{
        type: Directive,
        args: [{
                selector: '[mmTestId]'
            }]
    }], null, { input: [{
            type: Input,
            args: ['mmTestId']
        }] }); })();

class TestLoadingDirective extends BaseQaLocatorDirective {
    constructor() {
        super(...arguments);
        this.inputDataType = 'boolean';
        this.attributeName = QaLocatorTypes.loading;
    }
    ngOnChanges() {
        this.validate();
        this.setupLocator();
    }
    setupLocator() {
        this.overridedInput = this.input ? 'load' : 'ready';
        super.setupLocator();
    }
}
TestLoadingDirective.ɵfac = function TestLoadingDirective_Factory(t) { return ɵTestLoadingDirective_BaseFactory(t || TestLoadingDirective); };
TestLoadingDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TestLoadingDirective, selectors: [["", "mmTestLoading", ""]], inputs: { input: ["mmTestLoading", "input"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature] });
TestLoadingDirective.propDecorators = {
    input: [{ type: Input, args: ['mmTestLoading',] }]
};
const ɵTestLoadingDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(TestLoadingDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TestLoadingDirective, [{
        type: Directive,
        args: [{
                selector: '[mmTestLoading]'
            }]
    }], null, { input: [{
            type: Input,
            args: ['mmTestLoading']
        }] }); })();

class TestTargetDirective extends BaseQaLocatorDirective {
    constructor() {
        super(...arguments);
        this.attributeName = QaLocatorTypes.target;
        this.shouldBeUsedWithIdLocator = false;
    }
}
TestTargetDirective.ɵfac = function TestTargetDirective_Factory(t) { return ɵTestTargetDirective_BaseFactory(t || TestTargetDirective); };
TestTargetDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TestTargetDirective, selectors: [["", "mmTestTarget", ""]], inputs: { input: ["mmTestTarget", "input"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
TestTargetDirective.propDecorators = {
    input: [{ type: Input, args: ['mmTestTarget',] }]
};
const ɵTestTargetDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(TestTargetDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TestTargetDirective, [{
        type: Directive,
        args: [{
                selector: '[mmTestTarget]'
            }]
    }], null, { input: [{
            type: Input,
            args: ['mmTestTarget']
        }] }); })();

class TestTypeDirective extends BaseQaLocatorDirective {
    constructor() {
        super(...arguments);
        this.attributeName = QaLocatorTypes.type;
    }
}
TestTypeDirective.ɵfac = function TestTypeDirective_Factory(t) { return ɵTestTypeDirective_BaseFactory(t || TestTypeDirective); };
TestTypeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TestTypeDirective, selectors: [["", "mmTestType", ""]], inputs: { input: ["mmTestType", "input"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
TestTypeDirective.propDecorators = {
    input: [{ type: Input, args: ['mmTestType',] }]
};
const ɵTestTypeDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(TestTypeDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TestTypeDirective, [{
        type: Directive,
        args: [{
                selector: '[mmTestType]'
            }]
    }], null, { input: [{
            type: Input,
            args: ['mmTestType']
        }] }); })();

class TestStateDirective extends BaseQaLocatorDirective {
    constructor() {
        super(...arguments);
        this.attributeName = QaLocatorTypes.state;
        this.shouldBeUsedWithIdLocator = false;
    }
    ngOnChanges() {
        this.validate();
        this.setupLocator();
    }
}
TestStateDirective.ɵfac = function TestStateDirective_Factory(t) { return ɵTestStateDirective_BaseFactory(t || TestStateDirective); };
TestStateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TestStateDirective, selectors: [["", "mmTestState", ""]], inputs: { input: ["mmTestState", "input"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature] });
TestStateDirective.propDecorators = {
    input: [{ type: Input, args: ['mmTestState',] }]
};
const ɵTestStateDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(TestStateDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TestStateDirective, [{
        type: Directive,
        args: [{
                selector: '[mmTestState]'
            }]
    }], null, { input: [{
            type: Input,
            args: ['mmTestState']
        }] }); })();

class QaLocatorsModule {
    static forRoot(config) {
        return {
            ngModule: QaLocatorsModule,
            providers: [
                {
                    provide: QaLocatorsConfigToken,
                    useValue: config,
                },
            ],
        };
    }
}
QaLocatorsModule.ɵfac = function QaLocatorsModule_Factory(t) { return new (t || QaLocatorsModule)(); };
QaLocatorsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: QaLocatorsModule });
QaLocatorsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(QaLocatorsModule, { declarations: [TestIdDirective, TestLoadingDirective, TestTargetDirective, TestTypeDirective, TestStateDirective], exports: [TestIdDirective, TestLoadingDirective, TestTargetDirective, TestTypeDirective, TestStateDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QaLocatorsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TestIdDirective,
                    TestLoadingDirective,
                    TestTargetDirective,
                    TestTypeDirective,
                    TestStateDirective,
                ],
                exports: [
                    TestIdDirective,
                    TestLoadingDirective,
                    TestTargetDirective,
                    TestTypeDirective,
                    TestStateDirective,
                ]
            }]
    }], null, null); })();

const isEmpty = (value) => {
    if (!value && value !== 0) {
        return true;
    }
    if (isNumber(value)) {
        return false;
    }
    if (isString(value)) {
        return !value.trim();
    }
    if (isPlainObject(value) && value) {
        return !Object.keys(value).length;
    }
    if (isArray(value)) {
        return !value.length;
    }
    return true;
};
const isNumeric = value => /^-?\d*\.?\d+$/.test(value);
const clearObject = obj => {
    const result = {};
    Object.keys(obj).forEach((key) => {
        if (obj[key] || isBoolean(obj[key]) || isNumber(obj[key])) {
            result[key] = obj[key];
        }
    });
    return result;
};
const clearDeepObject = (obj) => Object.keys(obj).reduce((acc, key) => {
    if (isPlainObject(obj[key]) && !isEmpty(obj[key])) {
        const clearedObject = clearObject(obj[key]);
        if (!isEmpty(clearedObject)) {
            acc[key] = clearedObject;
        }
    }
    else if (isBoolean(obj[key]) || isArray(obj[key]) || !isEmpty(obj[key])) {
        acc[key] = obj[key];
    }
    return acc;
}, {});

const paramsBuilder = {
    process(parentKeys, key, value) {
        let params = {};
        const keys = this.concatKeys(parentKeys, key);
        if (isArray(value)) {
            params = Object.assign(Object.assign({}, params), this.processArray(keys, value));
        }
        else if (isPlainObject(value)) {
            params = Object.assign(Object.assign({}, params), this.processObject(keys, value));
        }
        else {
            const [primitiveKey, primitiveValue] = this.processPrimitive(parentKeys, key, value);
            params[primitiveKey] = primitiveValue;
        }
        return clearDeepObject(params);
    },
    processArray(parentKeys, array) {
        return array.reduce((accumulator, arrayValue) => {
            const [keyName, value] = this.processPrimitive(parentKeys, '', arrayValue);
            return Object.assign(Object.assign({}, accumulator), { [keyName]: accumulator[keyName] ? [].concat(accumulator[keyName], value) : value });
        }, {});
    },
    processObject(parentKeys, object) {
        const objectKeys = Object.keys(object);
        return objectKeys.reduce((accumulator, objectKey) => {
            const stringifiedObjectValue = this.process(parentKeys, objectKey, object[objectKey]);
            return Object.assign(Object.assign({}, accumulator), stringifiedObjectValue);
        }, {});
    },
    processPrimitive(parentKeys, key, primitive) {
        const keys = this.concatKeys(parentKeys, key);
        const keyName = this.createKeyName(keys);
        return [keyName, primitive];
    },
    concatKeys(parentKeys, key) {
        return !isUndefined(key) ? parentKeys.concat(key) : parentKeys;
    },
    createKeyName(keys) {
        const wrappedKeys = keys.map((key, index) => {
            const shouldWrap = index !== 0;
            if (shouldWrap) {
                return this.wrapKey(key);
            }
            return key;
        });
        return wrappedKeys.join('');
    },
    wrapKey(key) {
        return `[${key}]`;
    },
};
const queryBuilder = {
    toParams(object) {
        return paramsBuilder.process([], undefined, object);
    },
};

const urlQueryBuilder = {
    getEncodedKeyAlias(key) {
        const encodedAlias = { filter: 'f', sort: 's' };
        return encodedAlias[key] || key;
    },
    getDecodedKeyAlias(key) {
        const decodedAlias = { f: 'filter', s: 'sort' };
        return decodedAlias[key] || key;
    },
    encode(value, parentKey) {
        return Object.keys(value).reduce((acc, key) => {
            const currentKey = this.createKey(parentKey, key);
            if (isPlainObject(value[key])) {
                return Object.assign(Object.assign({}, acc), this.encode(value[key], currentKey));
            }
            else {
                acc[currentKey] = value[key];
                return acc;
            }
        }, {});
    },
    decode(value) {
        const obgWithEncodedKeys = Object.keys(value).reduce((acc, key) => {
            return set(acc, key, value[key]);
        }, {});
        return Object.keys(obgWithEncodedKeys).reduce((acc, key) => {
            const decodedKeyAlias = this.getDecodedKeyAlias(key);
            acc[decodedKeyAlias] = obgWithEncodedKeys[key];
            return acc;
        }, {});
    },
    createKey(parentKey, currentKey) {
        const encodedKeyAlias = this.getEncodedKeyAlias(currentKey);
        return parentKey ? `${parentKey}.${currentKey}` : encodedKeyAlias;
    },
};
const urlBuilder = {
    encode(value) {
        return urlQueryBuilder.encode(value, undefined);
    },
    decode(value) {
        return urlQueryBuilder.decode(value);
    }
};

const AUTH_CONFIG_TOKEN = new InjectionToken('SDK/AuthConfig');

var AuthEndpointEnum;
(function (AuthEndpointEnum) {
    AuthEndpointEnum["REFRESH"] = "REFRESH";
    AuthEndpointEnum["LOGIN"] = "LOGIN";
    AuthEndpointEnum["LOGOUT"] = "LOGOUT";
    AuthEndpointEnum["CREDENTIALS"] = "CREDENTIALS";
    AuthEndpointEnum["RESET"] = "RESET";
})(AuthEndpointEnum || (AuthEndpointEnum = {}));
const DEFAULT_AUTH_ENDPOINTS = {
    [AuthEndpointEnum.CREDENTIALS]: '/accounts/credentials',
    [AuthEndpointEnum.LOGIN]: '/accounts/auth/login',
    [AuthEndpointEnum.LOGOUT]: '/accounts/auth/logout',
    [AuthEndpointEnum.REFRESH]: '/accounts/auth/refresh-access',
    [AuthEndpointEnum.RESET]: '/accounts/reset-password',
};
const AUTH_ENDPOINTS_WITHOUT_TOKEN = [
    DEFAULT_AUTH_ENDPOINTS[AuthEndpointEnum.LOGIN],
    DEFAULT_AUTH_ENDPOINTS[AuthEndpointEnum.REFRESH],
];

const UNAUTHORIZED_STATUS_CODE = 401;

const STORAGE_KEY = '@metromarkets/storage';

class StorageSubject extends BehaviorSubject {
    constructor(initialValue) {
        super({
            oldValue: null,
            value: initialValue,
        });
    }
    next(newValue) {
        const storageSubjectValue = this.getValue();
        super.next({
            oldValue: storageSubjectValue.value,
            value: newValue,
        });
    }
}

var StorageUtil;
(function (StorageUtil) {
    function toWebStorageItemValue(storageItemValue) {
        const isString = typeof storageItemValue === 'string';
        const webStorageItemValue = !isString ? JSON.stringify(storageItemValue) : storageItemValue;
        return webStorageItemValue;
    }
    StorageUtil.toWebStorageItemValue = toWebStorageItemValue;
    function toStorageItemValue(webStorageItemValue) {
        try {
            const storageItemValue = JSON.parse(webStorageItemValue);
            return storageItemValue;
        }
        catch (err) {
            return webStorageItemValue;
        }
    }
    StorageUtil.toStorageItemValue = toStorageItemValue;
})(StorageUtil || (StorageUtil = {}));

class Storage {
    constructor(webStorage, storageSubjects) {
        this.webStorage = webStorage;
        this.storageSubjects = storageSubjects;
        this.initialize();
    }
    get length() {
        return this.webStorage.length;
    }
    set(key, newStorageItemValue) {
        const webStorageItemValue = StorageUtil.toWebStorageItemValue(newStorageItemValue);
        this.observe(key).next(newStorageItemValue);
        this.webStorage.setItem(key, webStorageItemValue);
    }
    get(key) {
        const webStorageItemValue = this.webStorage.getItem(key);
        const storageItemValue = StorageUtil.toStorageItemValue(webStorageItemValue);
        return storageItemValue;
    }
    remove(key) {
        this.observe(key).next(null);
        this.webStorage.removeItem(key);
    }
    clear() {
        const storageSubjectKeys = Object.keys(this.storageSubjects);
        storageSubjectKeys.forEach((storageSubjectKey) => {
            this.observe(storageSubjectKey).next(null);
        });
        this.webStorage.clear();
    }
    observe(key) {
        const existingStorageSubject = this.getStorageSubject(key);
        const hasExistingStorageSubject = Boolean(existingStorageSubject);
        if (hasExistingStorageSubject) {
            return existingStorageSubject;
        }
        const newStorageSubject = this.createStorageSubject(key);
        this.setStorageSubject(key, newStorageSubject);
        return newStorageSubject;
    }
    initialize() {
        const hasNotStorageSubjects = isEmpty$1(this.storageSubjects);
        if (hasNotStorageSubjects) {
            const webStorageItemKeys = Object.keys(this.webStorage);
            webStorageItemKeys.forEach(storageItemKey => {
                const storageSubject = this.createStorageSubject(storageItemKey);
                this.setStorageSubject(storageItemKey, storageSubject);
            });
        }
    }
    createStorageSubject(key) {
        const storageItemValue = this.get(key);
        const storageSubject = new StorageSubject(storageItemValue);
        return storageSubject;
    }
    getStorageSubject(key) {
        return this.storageSubjects[key];
    }
    setStorageSubject(key, subject) {
        this.storageSubjects[key] = subject;
    }
}

class StorageService {
    constructor(platformId) {
        this.platformId = platformId;
        if (isPlatformBrowser(this.platformId)) {
            this.initializeForBrowser();
        }
        else {
            // @todo: Implement initialization flow for SSR
        }
    }
    initializeForBrowser() {
        this.initializeAttributes();
        this.local = new Storage(window.localStorage, this.attributes.localStorageSubjects);
        this.session = new Storage(window.sessionStorage, this.attributes.sessionStorageSubjects);
        this.subscribeToStorageEvents();
    }
    initializeAttributes() {
        const hasStorageAttributesInWindow = Boolean(window[STORAGE_KEY]);
        if (!hasStorageAttributesInWindow) {
            window[STORAGE_KEY] = {
                isStorageEventsListened: false,
                sessionStorageSubjects: {},
                localStorageSubjects: {},
            };
        }
        this.attributes = window[STORAGE_KEY];
    }
    subscribeToStorageEvents() {
        if (this.attributes.isStorageEventsListened) {
            return;
        }
        window.addEventListener('storage', ({ key, oldValue, newValue }) => {
            const isStorageUpdate = Boolean(key);
            if (isStorageUpdate) {
                const storageItemValue = StorageUtil.toStorageItemValue(newValue);
                this.local.observe(key).next(storageItemValue);
            }
            else {
                this.local.clear();
            }
        });
        this.attributes.isStorageEventsListened = true;
    }
}
StorageService.ɵfac = function StorageService_Factory(t) { return new (t || StorageService)(ɵngcc0.ɵɵinject(PLATFORM_ID)); };
StorageService.ɵprov = ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(ɵɵinject(PLATFORM_ID)); }, token: StorageService, providedIn: "root" });
StorageService.ctorParameters = () => [
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

const STORAGE_KEY$1 = 'sdk/auth';
class AuthDataService {
    constructor(storageService) {
        this.storageService = storageService;
    }
    get authData() {
        return this.storageService.local.get(STORAGE_KEY$1);
    }
    set authData(authData) {
        if (authData) {
            this.storageService.local.set(STORAGE_KEY$1, authData);
        }
        else {
            this.storageService.local.remove(STORAGE_KEY$1);
        }
    }
    get authorizationHeader() {
        return this.authData ? `${this.authData.token_type} ${this.authData.access_token}` : null;
    }
    get refreshToken() {
        return this.authData ? this.authData.refresh_token : null;
    }
    get hasAuthData() {
        return Boolean(this.authData);
    }
}
AuthDataService.ɵfac = function AuthDataService_Factory(t) { return new (t || AuthDataService)(ɵngcc0.ɵɵinject(StorageService)); };
AuthDataService.ɵprov = ɵɵdefineInjectable({ factory: function AuthDataService_Factory() { return new AuthDataService(ɵɵinject(StorageService)); }, token: AuthDataService, providedIn: "root" });
AuthDataService.ctorParameters = () => [
    { type: StorageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: StorageService }]; }, null); })();

class AuthService {
    constructor(authConfig, http, authDataService) {
        this.http = http;
        this.authDataService = authDataService;
        this.isUserLoggedIn$ = new ReplaySubject(1);
        this.isRefreshInProgress = false;
        this.baseUrl = authConfig.baseUrl;
        this.authLinks = authConfig.authEndpoints;
        this.isLoggedIn$ = this.isUserLoggedIn$.asObservable();
        this.isUserLoggedIn$.next(Boolean(this.authDataService.authorizationHeader));
    }
    setToken(authData, preventStatusPublishing) {
        this.authDataService.authData = authData;
        if (!preventStatusPublishing) {
            this.isUserLoggedIn$.next(Boolean(authData));
        }
    }
    login(loginRequest) {
        const loginEndpoint = this.getEndpoint(AuthEndpointEnum.LOGIN);
        return this.http.post(`${this.baseUrl}${loginEndpoint}`, loginRequest).pipe(tap((authData) => {
            this.authDataService.authData = authData;
            this.isUserLoggedIn$.next(Boolean(authData));
        }));
    }
    logout(withIMSLogout = false) {
        // Remove the isIMSLogoutSkipped parameter and this code after MPGD-12489 implementation on IMS
        if (!withIMSLogout) {
            this.authDataService.authData = null;
            this.isUserLoggedIn$.next(false);
            return of(null);
        }
        const logoutEndpoint = this.getEndpoint(AuthEndpointEnum.LOGOUT);
        return this.http.get(`${this.baseUrl}${logoutEndpoint}`).pipe(mapTo(null), catchError((error) => {
            return error instanceof HttpErrorResponse && error.status === UNAUTHORIZED_STATUS_CODE
                ? of(null)
                : throwError(error);
        }), tap(() => {
            this.authDataService.authData = null;
            this.isUserLoggedIn$.next(false);
        }));
    }
    changePassword(oldPassword, newPassword) {
        const credentialsEndpoint = this.getEndpoint(AuthEndpointEnum.CREDENTIALS);
        const body = {
            old_password: oldPassword,
            new_password: newPassword,
        };
        return this.http.patch(`${this.baseUrl}${credentialsEndpoint}`, body);
    }
    getResetPasswordCode(email) {
        const resetEndpoint = this.getEndpoint(AuthEndpointEnum.RESET);
        return this.http.post(`${this.baseUrl}${resetEndpoint}/code`, { email });
    }
    resetPassword(code, password) {
        const resetEndpoint = this.getEndpoint(AuthEndpointEnum.RESET);
        return this.http.patch(`${this.baseUrl}${resetEndpoint}`, { code, password });
    }
    refreshAccessToken() {
        const refreshEndpoint = this.getEndpoint(AuthEndpointEnum.REFRESH);
        if (!this.isRefreshInProgress) {
            this.isRefreshInProgress = true;
            this.refreshAccessTokenRequest$ = this.http.post(`${this.baseUrl}${refreshEndpoint}`, { 'refresh_token': this.authDataService.refreshToken })
                .pipe(tap((authData) => {
                this.authDataService.authData = authData;
            }), catchError((error) => {
                this.logout();
                return throwError(error);
            }), finalize(() => {
                this.isRefreshInProgress = false;
            }), share());
        }
        return this.refreshAccessTokenRequest$;
    }
    addAuthorizationHeader(request) {
        return this.authDataService.hasAuthData
            ? request.clone({
                headers: request.headers.set('Authorization', this.authDataService.authorizationHeader)
            })
            : request;
    }
    getEndpoint(type) {
        switch (type) {
            case AuthEndpointEnum.RESET:
                return (this.authLinks && this.authLinks.resetPassword) || DEFAULT_AUTH_ENDPOINTS[AuthEndpointEnum.RESET];
            case AuthEndpointEnum.REFRESH:
                return (this.authLinks && this.authLinks.refreshToken) || DEFAULT_AUTH_ENDPOINTS[AuthEndpointEnum.REFRESH];
            case AuthEndpointEnum.LOGIN:
                return (this.authLinks && this.authLinks.login) || DEFAULT_AUTH_ENDPOINTS[AuthEndpointEnum.LOGIN];
            case AuthEndpointEnum.CREDENTIALS:
                return (this.authLinks && this.authLinks.credentials) || DEFAULT_AUTH_ENDPOINTS[AuthEndpointEnum.CREDENTIALS];
            case AuthEndpointEnum.LOGOUT:
                return (this.authLinks && this.authLinks.logout) || DEFAULT_AUTH_ENDPOINTS[AuthEndpointEnum.LOGOUT];
        }
    }
}
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵngcc0.ɵɵinject(AUTH_CONFIG_TOKEN), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(AuthDataService)); };
AuthService.ɵprov = ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(ɵɵinject(AUTH_CONFIG_TOKEN), ɵɵinject(HttpClient), ɵɵinject(AuthDataService)); }, token: AuthService, providedIn: "root" });
AuthService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_CONFIG_TOKEN,] }] },
    { type: HttpClient },
    { type: AuthDataService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_CONFIG_TOKEN]
            }] }, { type: ɵngcc1.HttpClient }, { type: AuthDataService }]; }, null); })();

class UnauthorizedInterceptor {
    constructor(authService, authConfig) {
        this.authService = authService;
        const logoutPath = DEFAULT_AUTH_ENDPOINTS[AuthEndpointEnum.LOGOUT];
        this.logoutUrl = `${authConfig.baseUrl || ''}${logoutPath}`;
    }
    intercept(request, next) {
        return next.handle(request).pipe(catchError((error) => {
            const isAuthorizationError = error.status === UNAUTHORIZED_STATUS_CODE;
            const url = request.url;
            const isLogoutRequest = url === this.logoutUrl;
            if (!isAuthorizationError || isLogoutRequest) {
                return throwError(error);
            }
            return this.authService.refreshAccessToken().pipe(switchMap(() => {
                return next.handle(this.authService.addAuthorizationHeader(request));
            }));
        }));
    }
}
UnauthorizedInterceptor.ɵfac = function UnauthorizedInterceptor_Factory(t) { return new (t || UnauthorizedInterceptor)(ɵngcc0.ɵɵinject(AuthService), ɵngcc0.ɵɵinject(AUTH_CONFIG_TOKEN)); };
UnauthorizedInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: UnauthorizedInterceptor, factory: UnauthorizedInterceptor.ɵfac });
UnauthorizedInterceptor.ctorParameters = () => [
    { type: AuthService },
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_CONFIG_TOKEN,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UnauthorizedInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthService }, { type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_CONFIG_TOKEN]
            }] }]; }, null); })();

class AuthInterceptor {
    constructor(authConfig, authService) {
        this.authService = authService;
        this.excludedUrls = [
            ...AUTH_ENDPOINTS_WITHOUT_TOKEN.map((endpoint) => `${authConfig.baseUrl || ''}${endpoint}`),
            ...(authConfig.excludedUrls || []),
        ].map((excludedUrl) => new RegExp(excludedUrl));
    }
    intercept(request, next) {
        const shouldAttachAuthHeader = this.isRequestNotExcluded(request);
        if (shouldAttachAuthHeader) {
            return next.handle(this.authService.addAuthorizationHeader(request));
        }
        return next.handle(request);
    }
    isRequestNotExcluded(request) {
        return !this.excludedUrls.some(excludedUrlRegexp => excludedUrlRegexp.test(request.url));
    }
}
AuthInterceptor.ɵfac = function AuthInterceptor_Factory(t) { return new (t || AuthInterceptor)(ɵngcc0.ɵɵinject(AUTH_CONFIG_TOKEN), ɵngcc0.ɵɵinject(AuthService)); };
AuthInterceptor.ɵprov = ɵɵdefineInjectable({ factory: function AuthInterceptor_Factory() { return new AuthInterceptor(ɵɵinject(AUTH_CONFIG_TOKEN), ɵɵinject(AuthService)); }, token: AuthInterceptor, providedIn: "root" });
AuthInterceptor.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_CONFIG_TOKEN,] }] },
    { type: AuthService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthInterceptor, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_CONFIG_TOKEN]
            }] }, { type: AuthService }]; }, null); })();

class AuthModule {
    static forRoot(configProvider) {
        return {
            ngModule: AuthModule,
            providers: [
                configProvider,
                AuthService,
                { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
                { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true },
            ],
        };
    }
}
AuthModule.ɵfac = function AuthModule_Factory(t) { return new (t || AuthModule)(); };
AuthModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AuthModule });
AuthModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            HttpClientModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthModule, { imports: function () { return [HttpClientModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule,
                ]
            }]
    }], null, null); })();

class AuthData {
}

class QueryUiStateService {
    constructor() {
        this.queryUiStateSource = new ReplaySubject(1);
        this.queryUiState = this.queryUiStateSource.asObservable();
    }
    updateQueryUiState(nextQuery) {
        this.queryUiStateSource.next(nextQuery);
    }
}
QueryUiStateService.ɵfac = function QueryUiStateService_Factory(t) { return new (t || QueryUiStateService)(); };
QueryUiStateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: QueryUiStateService, factory: QueryUiStateService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QueryUiStateService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class FilterWrapperComponent {
    constructor(queryUIStateSrv) {
        this.queryUIStateSrv = queryUIStateSrv;
        this.useUrl = true;
        this.setValue = new EventEmitter();
        this.updateCustomQueryState = new EventEmitter();
    }
    updateQueryState(queryState) {
        this.useUrl
            ? this.queryUIStateSrv.updateQueryUiState(queryState)
            : this.updateCustomQueryState.emit(queryState);
    }
    ngOnInit() {
        this.getQueryStateSelector();
        this.getQueryState();
    }
    getQueryState() {
        this.queryStateSubscription$ = this.queryState$.subscribe(qUi => {
            this.queryState = qUi;
            this.value = this.getValue(qUi);
            this.setValue.emit(this.value);
        });
    }
    getQueryStateSelector() {
        this.queryState$ = this.useUrl
            ? this.queryUIStateSrv.queryUiState
            : this.customQueryState$;
    }
    getValue(queryUiState) {
        const { filter = {} } = queryUiState;
        const value = filter[this.filterKey];
        return !isEmpty(value) || isBoolean(value) ? value : null;
    }
    onChange(value) {
        const _a = this.queryState, { filter = {} } = _a, rest = __rest(_a, ["filter"]);
        const nextParams = Object.assign(Object.assign({}, rest), { filter: Object.assign(Object.assign({}, filter), { [this.filterKey]: value }) });
        this.updateQueryState(nextParams);
    }
    ngOnDestroy() {
        this.queryStateSubscription$.unsubscribe();
    }
}
FilterWrapperComponent.ɵfac = function FilterWrapperComponent_Factory(t) { return new (t || FilterWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(QueryUiStateService)); };
FilterWrapperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FilterWrapperComponent, selectors: [["mm-filter-wrapper"]], inputs: { useUrl: "useUrl", customQueryState$: "customQueryState$", filterKey: "filterKey" }, outputs: { setValue: "setValue", updateCustomQueryState: "updateCustomQueryState" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function FilterWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
FilterWrapperComponent.ctorParameters = () => [
    { type: QueryUiStateService }
];
FilterWrapperComponent.propDecorators = {
    useUrl: [{ type: Input }],
    customQueryState$: [{ type: Input }],
    filterKey: [{ type: Input }],
    setValue: [{ type: Output }],
    updateCustomQueryState: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'mm-filter-wrapper',
                template: "<ng-content></ng-content>\n"
            }]
    }], function () { return [{ type: QueryUiStateService }]; }, { useUrl: [{
            type: Input
        }], setValue: [{
            type: Output
        }], updateCustomQueryState: [{
            type: Output
        }], customQueryState$: [{
            type: Input
        }], filterKey: [{
            type: Input
        }] }); })();

class ListWrapperComponent {
    constructor(activatedRoute, queryUIStateSrv, router) {
        this.activatedRoute = activatedRoute;
        this.queryUIStateSrv = queryUIStateSrv;
        this.router = router;
        this.useUrl = true;
        this.updateCustomQueryState = new EventEmitter();
        this.getData = new EventEmitter();
        this.getQueryState = new EventEmitter();
    }
    ngOnInit() {
        this.getQueryStateSelector();
        this.loadData();
        this.initialLoad();
    }
    getQueryStateSelector() {
        this.queryState$ = this.useUrl
            ? this.queryUIStateSrv.queryUiState
            : this.customQueryState$;
    }
    updateQueryState(queryState) {
        if (this.useUrl) {
            this.queryUIStateSrv.updateQueryUiState(queryState);
        }
        else {
            this.updateCustomQueryState.emit(queryState);
        }
    }
    updateQueryParams(queryState) {
        const encodedQuery = urlBuilder.encode(queryState);
        this.router.navigate([], { queryParams: encodedQuery });
    }
    loadData() {
        this.queryStateSubscription$ = this.queryState$.subscribe(qUi => {
            this.getQueryState.emit(qUi);
            if (this.useUrl) {
                this.updateQueryParams(qUi);
            }
            this.getData.emit(qUi);
        });
    }
    initialLoad() {
        const { queryParams } = this.activatedRoute.snapshot;
        const initQuery = this.initQueryState || {};
        const nextQuery = isEmpty(queryParams) ? initQuery : urlBuilder.decode(queryParams);
        this.updateQueryState(nextQuery);
    }
    ngOnDestroy() {
        this.queryStateSubscription$.unsubscribe();
        this.queryUIStateSrv.updateQueryUiState({});
    }
}
ListWrapperComponent.ɵfac = function ListWrapperComponent_Factory(t) { return new (t || ListWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(QueryUiStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router)); };
ListWrapperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ListWrapperComponent, selectors: [["mm-list-wrapper"]], inputs: { useUrl: "useUrl", customQueryState$: "customQueryState$", initQueryState: "initQueryState" }, outputs: { updateCustomQueryState: "updateCustomQueryState", getData: "getData", getQueryState: "getQueryState" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function ListWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
ListWrapperComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: QueryUiStateService },
    { type: Router }
];
ListWrapperComponent.propDecorators = {
    useUrl: [{ type: Input }],
    customQueryState$: [{ type: Input }],
    initQueryState: [{ type: Input }],
    updateCustomQueryState: [{ type: Output }],
    getData: [{ type: Output }],
    getQueryState: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'mm-list-wrapper',
                template: "<ng-content></ng-content>\n"
            }]
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }, { type: QueryUiStateService }, { type: ɵngcc2.Router }]; }, { useUrl: [{
            type: Input
        }], updateCustomQueryState: [{
            type: Output
        }], getData: [{
            type: Output
        }], getQueryState: [{
            type: Output
        }], customQueryState$: [{
            type: Input
        }], initQueryState: [{
            type: Input
        }] }); })();

class QueryUiStateModule {
}
QueryUiStateModule.ɵfac = function QueryUiStateModule_Factory(t) { return new (t || QueryUiStateModule)(); };
QueryUiStateModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: QueryUiStateModule });
QueryUiStateModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [QueryUiStateService], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(QueryUiStateModule, { declarations: function () { return [FilterWrapperComponent, ListWrapperComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FilterWrapperComponent, ListWrapperComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QueryUiStateModule, [{
        type: NgModule,
        args: [{
                declarations: [FilterWrapperComponent, ListWrapperComponent],
                imports: [CommonModule],
                providers: [QueryUiStateService],
                exports: [FilterWrapperComponent, ListWrapperComponent]
            }]
    }], null, null); })();

class StorageModule {
    static forRoot() {
        return {
            ngModule: StorageModule,
            providers: [StorageService],
        };
    }
}
StorageModule.ɵfac = function StorageModule_Factory(t) { return new (t || StorageModule)(); };
StorageModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: StorageModule });
StorageModule.ɵinj = ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StorageModule, [{
        type: NgModule
    }], null, null); })();

const FEATURE_TOGGLE_CONFIG_TOKEN = new InjectionToken('SDK/FeatureToggleConfig');

class FeatureToggleService {
    constructor(featureToggleConfig, httpClient) {
        this.httpClient = httpClient;
        this.toggleUrl = featureToggleConfig.toggleUrl;
    }
    ngOnInit() {
        this.setConfig();
    }
    isEnabled(featureName) {
        if (this.featureToggleConfig) {
            return of(this.featureToggleConfig[featureName]);
        }
        else {
            return this.setConfig()
                .pipe(tap((config) => {
                this.featureToggleConfig = config;
            }), map((config) => {
                const featureValue = this.featureToggleConfig[featureName];
                return (Number(featureValue) === 1);
            }));
        }
    }
    setConfig() {
        return this.httpClient.get(this.toggleUrl);
    }
}
FeatureToggleService.ɵfac = function FeatureToggleService_Factory(t) { return new (t || FeatureToggleService)(ɵngcc0.ɵɵinject(FEATURE_TOGGLE_CONFIG_TOKEN), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
FeatureToggleService.ɵprov = ɵɵdefineInjectable({ factory: function FeatureToggleService_Factory() { return new FeatureToggleService(ɵɵinject(FEATURE_TOGGLE_CONFIG_TOKEN), ɵɵinject(HttpClient)); }, token: FeatureToggleService, providedIn: "root" });
FeatureToggleService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [FEATURE_TOGGLE_CONFIG_TOKEN,] }] },
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FeatureToggleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [FEATURE_TOGGLE_CONFIG_TOKEN]
            }] }, { type: ɵngcc1.HttpClient }]; }, null); })();

class FeatureToggleDirective {
    constructor(featureToggleService, templateRef, viewContainer, changeDetection) {
        this.featureToggleService = featureToggleService;
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.changeDetection = changeDetection;
    }
    ngOnInit() {
        if (!this.featureName) {
            throw new Error('Attribute `featureToggle` should not be null or empty');
        }
        this.shouldRender();
    }
    shouldRender() {
        this.featureToggleService.isEnabled(this.featureName)
            .subscribe((isEnabled) => {
            if (isEnabled) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
            else {
                this.viewContainer.clear();
            }
            this.changeDetection.detectChanges();
        });
    }
}
FeatureToggleDirective.ɵfac = function FeatureToggleDirective_Factory(t) { return new (t || FeatureToggleDirective)(ɵngcc0.ɵɵdirectiveInject(FeatureToggleService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
FeatureToggleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FeatureToggleDirective, selectors: [["", "featureToggle", ""]], inputs: { featureName: ["featureToggle", "featureName"] } });
FeatureToggleDirective.ctorParameters = () => [
    { type: FeatureToggleService },
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: ChangeDetectorRef }
];
FeatureToggleDirective.propDecorators = {
    featureName: [{ type: Input, args: ['featureToggle',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FeatureToggleDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[featureToggle]'
            }]
    }], function () { return [{ type: FeatureToggleService }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { featureName: [{
            type: Input,
            args: ['featureToggle']
        }] }); })();

class FeatureToggleWhenDisabledDirective {
    constructor(featureToggleService, templateRef, viewContainer, changeDetection) {
        this.featureToggleService = featureToggleService;
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.changeDetection = changeDetection;
    }
    ngOnInit() {
        if (!this.featureName) {
            throw new Error('Attribute `featureToggleWhenDisabled` should not be null or empty');
        }
        this.shouldRender();
    }
    shouldRender() {
        this.featureToggleService.isEnabled(this.featureName)
            .subscribe((isEnabled) => {
            if (!isEnabled) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
            else {
                this.viewContainer.clear();
            }
            this.changeDetection.detectChanges();
        });
    }
}
FeatureToggleWhenDisabledDirective.ɵfac = function FeatureToggleWhenDisabledDirective_Factory(t) { return new (t || FeatureToggleWhenDisabledDirective)(ɵngcc0.ɵɵdirectiveInject(FeatureToggleService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
FeatureToggleWhenDisabledDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FeatureToggleWhenDisabledDirective, selectors: [["", "featureToggleWhenDisabled", ""]], inputs: { featureName: ["featureToggleWhenDisabled", "featureName"] } });
FeatureToggleWhenDisabledDirective.ctorParameters = () => [
    { type: FeatureToggleService },
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: ChangeDetectorRef }
];
FeatureToggleWhenDisabledDirective.propDecorators = {
    featureName: [{ type: Input, args: ['featureToggleWhenDisabled',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FeatureToggleWhenDisabledDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[featureToggleWhenDisabled]'
            }]
    }], function () { return [{ type: FeatureToggleService }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { featureName: [{
            type: Input,
            args: ['featureToggleWhenDisabled']
        }] }); })();

class FeatureToggleModule {
    static forRoot(configProvider) {
        return {
            ngModule: FeatureToggleModule,
            providers: [
                configProvider,
                FeatureToggleService,
            ],
        };
    }
}
FeatureToggleModule.ɵfac = function FeatureToggleModule_Factory(t) { return new (t || FeatureToggleModule)(); };
FeatureToggleModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FeatureToggleModule });
FeatureToggleModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FeatureToggleModule, { declarations: function () { return [FeatureToggleDirective, FeatureToggleWhenDisabledDirective]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [FeatureToggleDirective, FeatureToggleWhenDisabledDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FeatureToggleModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FeatureToggleDirective,
                    FeatureToggleWhenDisabledDirective,
                ],
                exports: [
                    FeatureToggleDirective,
                    FeatureToggleWhenDisabledDirective,
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                ]
            }]
    }], null, null); })();

var Config;
(function (Config) {
    let mainConfig;
    const scopedConfigs = {};
    function initialize(config) {
        if (!mainConfig) {
            mainConfig = config;
        }
        else {
            throw new Error('MainConfig is already initialized');
        }
    }
    Config.initialize = initialize;
    function initializeScope(scopeName, scopedConfig) {
        if (!scopedConfigs[scopeName]) {
            scopedConfigs[scopeName] = scopedConfig;
        }
        else {
            throw new Error(`ScopedConfig(${scopeName}) is already initialized`);
        }
    }
    Config.initializeScope = initializeScope;
    function get(configPath) {
        const hasScope = configPath.indexOf('@') === 0;
        if (hasScope) {
            return getFromScope(configPath);
        }
        else if (!mainConfig) {
            throw new ReferenceError(`MainConfig isn't initialized`);
        }
        return _get(mainConfig, configPath);
    }
    Config.get = get;
    function getFromScope(configPathWithScope) {
        const [scope, configPath] = configPathWithScope.split('/');
        const scopeName = scope.slice(1);
        const scopedConfig = scopedConfigs[scopeName];
        if (scopedConfig) {
            return _get(scopedConfig, configPath);
        }
        else {
            throw new ReferenceError(`ScopedConfig(${scopeName}) isn't initialized`);
        }
    }
})(Config || (Config = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { AUTH_CONFIG_TOKEN, AuthData, AuthModule, AuthService, Config, FEATURE_TOGGLE_CONFIG_TOKEN, FeatureToggleModule, FeatureToggleService, QaLocatorsModule, QueryUiStateModule, QueryUiStateService, StorageModule, StorageService, queryBuilder, urlBuilder, TestIdDirective as ɵa, BaseQaLocatorDirective as ɵb, QaLocatorsConfigToken as ɵc, TestLoadingDirective as ɵe, TestTargetDirective as ɵf, TestTypeDirective as ɵg, TestStateDirective as ɵh, AuthDataService as ɵj, AuthInterceptor as ɵk, UnauthorizedInterceptor as ɵl, FilterWrapperComponent as ɵm, ListWrapperComponent as ɵn, FeatureToggleDirective as ɵo, FeatureToggleWhenDisabledDirective as ɵp };

//# sourceMappingURL=metromarkets-sdk.js.map